<template>
  <div style="margin-left: 20px; margin-top: 20px">
    <el-row>
      <el-col :span="12">
        <form-section :title="steps[currentStep.index].subtitle">
          <el-button @click="completeStep">
            complete step
          </el-button>

          <el-button @click="allowContinue">
            allow continue
          </el-button>
        </form-section>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import FormSection from '../../components/form/FormSection'

export default {
  name: 'StepOne',

  components: {
    FormSection
  },

  props: {
    currentStep: {
      type: Object,
      required: true
    },

    steps: {
      type: Array,
      required: true
    }
  },

  watch: {
    canGoToNext(value) {
      if (value === true) {
        this.$emit('can-continue', { value: true })
      }
    }
  },

  methods: {
    allowContinue() {
      this.$emit('can-continue', { value: true })
    },

    completeStep() {
      this.$emit('complete-step', this.currentStep.index)
    }
  },

  computed: {
    canGoToNext() {
      if (this.steps[this.currentStep.index].completed === true) {
        return true
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/common/tests/page/StepOne.vue